// joinContext.js: keeps a free-tool share code (/free/<tool>?join=CODE) through sign-in.
// Captured before render, like invitationContext.js, because signed-out visitors are sent
// to / and the query string would otherwise be lost.
export function createJoinContext(pathPrefixes, storageKey) {
  const prefixes = [].concat(pathPrefixes);
  let pending;
  function get() {
    if (pending !== undefined) return pending;
    const url = new URL(window.location.href);
    const code = prefixes.some(p => url.pathname.startsWith(p)) ? url.searchParams.get('join') : null;
    if (code && /^[A-Z0-9]{6,16}$/.test(code)) {
      pending = code;
      try { sessionStorage.setItem(storageKey, code); } catch (_) { /* memory fallback */ }
      url.searchParams.delete('join');
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } else {
      try { pending = sessionStorage.getItem(storageKey) || null; } catch (_) { pending = null; }
    }
    return pending;
  }
  function clear() {
    pending = null;
    try { sessionStorage.removeItem(storageKey); } catch (_) { /* memory fallback */ }
  }
  return { get, clear };
}

const vote = createJoinContext('/free/vote', 'argumentor-pending-vote-join');
export const getPendingVoteJoin = vote.get;
export const clearPendingVoteJoin = vote.clear;
